module.exports = __webpack_public_path__ + "k.no2.3d4f88b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/k.no2.jpg
// module id = krVd
// module chunks = 0